import React from 'react';
import {Button} from 'tinper-bee'
class PackagesStatistics extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
    }

    render() {
        const { data } = this.props
        return (
            <div className='packages-statictics-container'>
                <div className='info'>
                    <div className='info-content'>
                        <div className='item'>

                            <p>{data ? data.user_total : '--'}</p>
                            用户个数

                        </div>
                        <div className='item'>
                            <div style={{
                                borderLeft: '1px solid #E9E9E9',
                                borderRight: '1px solid #E9E9E9'
                            }}>
                                <p>{data ? data.com_total : '--'}</p>
                                物料总数
                            </div>
                        </div>
                        <div className='item'>
                            <p style={{fontSize: '16px'}}>{data ? data.download_total : '--'}</p>
                            下载总数
                        </div>
                    </div>
                </div>
              
            </div>
        );
    }
}

export default PackagesStatistics;
